export default {"src":"/_next/static/media/arrow-right.d8039789.svg","height":4,"width":4,"blurWidth":0,"blurHeight":0};